import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

// 完整的静态路由表
const staticRoutes = [
	{
		path: "/",
		name: "首页",
		component: () => import("../views/HomeView.vue"),
	},
	{
		path: "/login",
		name: "登录",
		component: () => import("../views/LoginView.vue"),
		meta: { public: true },
	},
	{
		path: "/orderInfo",
		name: "订单详细信息",
		component: () => import("../views/OrderInfo.vue"),
	},
	{
		path: "/Order",
		name: "创建订单",
		component: () => import("../views/Order.vue"),
	},
	{
		path: "/OrderList",
		name: "历史订单",
		component: () => import("../views/OrderList.vue"),
	},
	{
		path: "/Invoice",
		name: "我的发票",
		component: () => import("../views/Invoice.vue"),
	},
	{
		path: "/UserExtra",
		name: "我的信息",
		component: () => import("../views/UserExtra.vue"),
	},
	{
		path: "/ChooseMarket",
		name: "我的市场",
		component: () => import("../views/ChooseMarket.vue"),
	},
	{
		path: "/ChooseReferee",
		name: "被介绍人",
		component: () => import("../views/ChooseReferee.vue"),
	},
	{
		path: "/Commission",
		name: "服务费信息",
		component: () => import("../views/Commission.vue"),
	},
	{
		path: "/Withdrawal",
		name: "提现申请",
		component: () => import("../views/Withdrawal.vue"),
	},
	{
		path: "/FolderView",
		name: "文件资源",
		component: () => import("../views/FolderView.vue"),
	},
		{
		path: "/FileView",
		name: "文件资源",
		component: () => import("../views/FileView.vue"),
	},
	{
		path: "*",
		redirect: "/login",
	},
];

// 菜单原始数据（更新图标）
const rawMenuList = [
	{
		menuId: "7",
		menuName: "订单",
		parentId: "0",
		menuUrl: "/",
		menuIcon: "el-icon-s-order", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "8",
		menuName: "创建订单",
		parentId: "7",
		menuUrl: "/Order",
		menuIcon: "el-icon-edit-outline", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "10",
		menuName: "历史订单",
		parentId: "7",
		menuUrl: "/OrderList",
		menuIcon: "el-icon-time", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "13",
		menuName: "我的发票",
		parentId: "7",
		menuUrl: "/Invoice",
		menuIcon: "el-icon-printer", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "14",
		menuName: "我的",
		parentId: "0",
		menuUrl: "/",
		menuIcon: "el-icon-user", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "9",
		menuName: "我的信息",
		parentId: "14",
		menuUrl: "/UserExtra",
		menuIcon: "el-icon-user-solid", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "11",
		menuName: "我的市场",
		parentId: "14",
		menuUrl: "/ChooseMarket",
		menuIcon: "el-icon-shopping-cart-2", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "12",
		menuName: "被介绍人",
		parentId: "14",
		menuUrl: "/ChooseReferee",
		menuIcon: "el-icon-share", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "15",
		menuName: "服务费信息",
		parentId: "14",
		menuUrl: "/Commission",
		menuIcon: "el-icon-coin", // 更新图标
		menuIndex: 0,
	},
	{
		menuId: "16",
		menuName: "提现申请",
		parentId: "14",
		menuUrl: "/Withdrawal",
		menuIcon: "el-icon-upload", // 更新图标
		menuIndex: 0,
	},

	{
		menuId: "17",
		menuName: "文件资源",
		parentId: "14",
		menuUrl: "/FolderView",
		menuIcon: "el-icon-s-management", // 更新图标
		menuIndex: 0,
	},
];

// 预处理菜单数据
const processedMenuList = rawMenuList.map((item) => ({
	...item,
	name: item.menuName,
	path: item.menuUrl,
}));

// 创建路由实例
const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes: staticRoutes,
});

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
	// 设置页面标题
	if (to.name) {
		document.title = to.name + "- 佳喜祥";
	} else {
		document.title = "佳喜祥管理系统";
	}

	const token = sessionStorage.getItem("external-token");

	if (token) {
		if (to.path === "/login") {
			next({ path: "/" });
		} else {
			if (!store.state.menuList || store.state.menuList.length === 0) {
				store.commit("SET_MENU_LIST", processedMenuList);
			}
			next();
		}
	} else {
		if (to.path === "/login") {
			next();
		} else {
			next(`/login?redirect=${to.path}`);
		}
	}
});

export default router;
